import { NETWORK_DOMAIN, NETWORK_KEY } from '../../constants'

const getRequestsNetworkSelect = state => state[NETWORK_DOMAIN][NETWORK_KEY.REQUESTS]

export default getRequestsNetworkSelect
